<mat-drawer-container class="container" autosize [hasBackdrop]="backdropOn" (backdropClick)="backdropClick()">
  <mobile-header></mobile-header>

  <mat-drawer *ngIf="authService.isAuthenticated()" #drawer [disableClose]="false" class="sidenav" [mode]="mode" [opened]="!navigationService.hide">

    <side-navigation></side-navigation>

    <ap-status></ap-status>

  </mat-drawer>

  <div class="sidenav-content">
      <router-outlet></router-outlet>
  </div>

</mat-drawer-container>
